/*global angular */
'use strict';

angular.module('MrDWebApp').controller('WalletCtrl', function ($scope,loginFactory, $http, profile, walletHistory, storage, $resource, baseURL) {

  var _wallet = this;

  $scope.loading = true;
  $scope.showPayoutProcess = false;
  $scope.showRequestPayoutModal = false;

  this.walletHistory = walletHistory;

  walletHistory.$promise.then(function(){
    $scope.loading = false;
  });

  $scope.goPayoutProcess = function(){
    $scope.showPayoutProcess = true;
  };
  $scope.closePayoutProcess = function(){
    $scope.showPayoutProcess = false;
  };
  $scope.goPayoutModal = function(){
    $scope.showRequestPayoutModal = true;
  };
  $scope.closeModal = function(){
    $scope.showRequestPayoutModal = false;
  };

  this.requestPayout = function () {
    $scope.showPayoutProcess = false;
    $scope.showRequestPayoutModal = false;

    console.log('Request Payout');

      // note: I tried to put the following in walletFactory, but it lost the user_id for some reason. So putting the
      //       $resource code right here.
      var user_id = $scope._rc.access.user.id;
      var walletResource = $resource(baseURL + 'v3/users/:userID/wallet/refunds', {'userID': user_id},
        {
          payout: { method: 'POST' }
        });

      var promise = walletResource.payout().$promise; // $wtf?
      promise.then(function(success) {
          console.log('success');
          _wallet.payout_success_message = 'Payout successfully requested';

      }, function (failure) {
          console.log('failure');
        console.log(failure);
        _wallet.payout_failure_message = failure.data.error.friendly_message;

      });

  };

});

